// Import dependencies
import React, { useRef,useEffect } from "react";
import * as tf from "@tensorflow/tfjs";
import githubIcon from './images/githubIcon.png';
// 1. IMPORT REQUIRED MODEL BASED ON OUR USE CASE: this could be changed
import * as cocossd from "@tensorflow-models/coco-ssd";
import Webcam from "react-webcam";
import "./App.css";
// 2. IMPORT FUNCTIONALITIES
import { drawRectangleOfDetection } from "./utilities";

function App() {
  //var related to Webcam: is a promt
  const webcamRef = useRef(null);
  //var related to Canvas: is a promt 
  const canvasRef = useRef(null);

  //Async function to load the model and execute the detect function
  const runCoco = async () => {
    // 3. LOAD OUR MODEL
    const net = await cocossd.load();
    //Try to detect within 10 seconds
    setInterval(() => {
      detection(net);
    }, 10);
  };

  //Async function that captures the video dimension
  // Video dimension data: render video dimension and canvas box 
  // Also make a prediction about the object 
  // return the canvas with the prediction
  const detection = async (net) => {
    // Check data is available
    if (
      typeof webcamRef.current !== "undefined" &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) {
      // Get Video Properties
      const video = webcamRef.current.video;
      const videoWidth = webcamRef.current.video.videoWidth;
      const videoHeight = webcamRef.current.video.videoHeight;

      // Set video width and height
      webcamRef.current.video.width = videoWidth;
      webcamRef.current.video.height = videoHeight;

      // Set canvas height and width
      canvasRef.current.width = videoWidth;
      canvasRef.current.height = videoHeight;

      // 4. MAKE DETECTION
      // video var is actually the video from our webcam
      const obj = await net.detect(video);
      //see the prediction for a debug task
      console.log(obj); 

      // Draw mesh
      const ctx = canvasRef.current.getContext("2d");

      // 5.USE FUNCTION to draw the CANVAS and put our prediction there...
      drawRectangleOfDetection(obj, ctx)  
    }
  };

  //re-run the first function again, and start the process again and again
  useEffect(()=>{runCoco()},[]);

  //return the react application
  return (
    <div className="App">

      <div className="header">
        <div className="info">
            <h1>VClassifier</h1>
            <h2>Author: Alejandro Meza</h2>
        </div>
      </div>

      <div className="dummy">
      </div>

      <div className="App-info-service">
        What is this? Vclassifier is a simple application capable of recognizing objects with your PC camera. To do this, it uses a ML model.
        Try to test the results! And most importantly, have fun!
      </div>

      <div className="App-body">
        <Webcam
          ref={webcamRef}
          muted={true} 
          imageSmoothing={true}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 9,
            width: 640,
            height: 480,
          }}
        />

        <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 8,
            width: 640,
            height: 480,
          }}
        />
      </div>
      
      <div className='VClassifierFooter'>
        <div className='logo'>
          <a href="https://github.com/jalex3421/Vclassifier">
            <img 
              src={githubIcon}
              alt='Vclassifier Github Link'
              className='githubIcon' />
          </a>
         </div>
        <div className='FooterTextCopyRight'>VClassifier ©   2023</div>
      </div>

    </div>
  );
}
export default App;
